var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tab-layout", {
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$l10n.__("Informations Générales")) +
                "\n    "
            )
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "div",
              { class: _vm.mainClasses },
              [
                _c("section", { staticClass: "flex" }, [
                  _c("h3", { staticClass: "m-3 flex-row baseline" }, [
                    _vm._v(_vm._s(_vm.$l10n.__("Le contact")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "px-3 br-1" }, [
                    _c("div", [
                      _c("h4", { staticClass: "m-0" }, [
                        _vm._v(_vm._s(_vm.$l10n.__("Personnelle")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "ul",
                        _vm._l(_vm.removeEmptyValue(_vm.general), function(
                          item,
                          indexItem
                        ) {
                          return _c(
                            "li",
                            {
                              key: indexItem,
                              staticClass: "data-block data-block-hover"
                            },
                            [
                              _c(
                                item.format + "-data",
                                _vm._b(
                                  {
                                    tag: "component",
                                    attrs: {
                                      useFavorite: !!item.favoriteName,
                                      list: _vm.favorites
                                    },
                                    on: {
                                      toggleFavorite: function($event) {
                                        return _vm.updateFavorites(item)
                                      }
                                    }
                                  },
                                  "component",
                                  item,
                                  false
                                )
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "flex" }, [
                  _c("h3", { staticClass: "m-3 flex-row baseline" }, [
                    _c(
                      "span",
                      { staticClass: "flex-right" },
                      [
                        _c(
                          "link-button",
                          {
                            attrs: {
                              permissions: _vm.$store.getters.permissions,
                              permToCheck: "can_edit",
                              "data-bot": _vm.databot["generalinfoedit1"]
                            },
                            on: { clicked: _vm.edit }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$l10n.__("Editer")) +
                                "\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "px-3" },
                    _vm._l(_vm.linkedThirds, function(third, thirdIndex) {
                      return _c("div", { key: thirdIndex }, [
                        _c("h4", { staticClass: "m-0" }, [
                          _vm._v(_vm._s(third.name))
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          _vm._l(_vm.removeEmptyValue(third.data), function(
                            item,
                            indexItem
                          ) {
                            return _c(
                              "li",
                              {
                                key: indexItem,
                                staticClass: "data-block data-block-hover"
                              },
                              [
                                _c(
                                  item.format + "-data",
                                  _vm._b(
                                    {
                                      tag: "component",
                                      attrs: {
                                        useFavorite:
                                          !!item.favoriteName &&
                                          thirdIndex === 0,
                                        list: _vm.favorites,
                                        index: thirdIndex
                                      },
                                      on: {
                                        toggleFavorite: function($event) {
                                          return _vm.updateFavorites(item)
                                        }
                                      }
                                    },
                                    "component",
                                    item,
                                    false
                                  )
                                )
                              ],
                              1
                            )
                          }),
                          0
                        )
                      ])
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("sellsy-informations-section", {
                  attrs: {
                    linkedid: _vm.$store.getters.linkedid,
                    linkedtype: _vm.$store.getters.linkedtype,
                    enableTags: true,
                    data: _vm.$store.getters.sellsyInformations,
                    canDisplayMassMailingConsent:
                      _vm.canDisplayMassMailingConsent
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.canDisplayMarketingConsent
              ? _c("MarketingConsentOverview")
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }